import DatePicker from '../../../../components/Forms/DatePicker/DatePicker';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { RestaurantWasteReason } from '../../../../types/restaurant/RestaurantCatalogExtensionTypes';
import { restaurantWasteReasonLabels } from '../restaurantWasteUtils';

interface WasteFiltersProps {
  search: string;
  categoryId: number;
  reason: RestaurantWasteReason | 'ALL';
  dateFrom: string;
  dateTo: string;
  categories: Array<{ id: number; name: string }>;
  onSearchChange: (value: string) => void;
  onCategoryChange: (value: number) => void;
  onReasonChange: (value: RestaurantWasteReason | 'ALL') => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
}

const WasteFilters = ({
  search,
  categoryId,
  reason,
  dateFrom,
  dateTo,
  categories,
  onSearchChange,
  onCategoryChange,
  onReasonChange,
  onDateFromChange,
  onDateToChange,
}: WasteFiltersProps) => (
  <div className="grid gap-4 border-b border-stroke p-5 dark:border-strokedark md:grid-cols-2 xl:grid-cols-5 xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="wasteSearch"
        value={search}
        iconKey="search"
        placeholder="Materia prima, código o usuario..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>
    <SelectField
      label="Categoría"
      name="wasteCategory"
      value={categoryId}
      options={[
        { value: 0, label: 'Todas las categorías' },
        ...categories.map((category) => ({ value: category.id, label: category.name })),
      ]}
      onChange={(event) => onCategoryChange(Number(event.target.value))}
    />
    <SelectField
      label="Motivo"
      name="wasteReason"
      value={reason}
      options={[
        { value: 'ALL', label: 'Todos los motivos' },
        ...Object.entries(restaurantWasteReasonLabels).map(([value, label]) => ({ value, label })),
      ]}
      onChange={(event) => onReasonChange(event.target.value as RestaurantWasteReason | 'ALL')}
    />
    <DatePicker label="Desde" name="wasteDateFrom" value={dateFrom} iconKey="calendar" onChange={onDateFromChange} />
    <DatePicker label="Hasta" name="wasteDateTo" value={dateTo} iconKey="calendar" onChange={onDateToChange} />
  </div>
);

export default WasteFilters;
